import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { StaticLinkBox } from '../landing-page-config/landing-page-config.model';
import { ProductContextService } from '../core/product-context.service';

@Component({
  selector: 'app-whitelabel',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './whitelabel.component.html',
  styleUrl: './whitelabel.component.scss'
})
export class WhitelabelComponent implements OnInit {
  public staticLinkBoxes: StaticLinkBox[] = [];

  private static readonly IMAGE_MAP: Record<string, string> = {
    REGISTER: 'assets/img/teaser-register.jpg',
    VIBOOKS:  'assets/img/teaser-vibooks.jpg',
    HOMEPAGE: 'assets/img/teaser-homepage.jpg',
  };

  private static readonly CTA_KEY_MAP: Record<string, string> = {
    REGISTER: 'link.cta.register',
    VIBOOKS:  'link.cta.vibooks',
    HOMEPAGE: 'link.cta.homepage',
  };

  constructor(
    private route: ActivatedRoute,
    private productContextService: ProductContextService,
    private translate: TranslateService
  ) {}

  private static resolveWhitelabelLocale(): string {
    return navigator.language?.toLowerCase().startsWith('de') ? 'de-DE' : 'en-DE';
  }

  ngOnInit(): void {
    const locale = WhitelabelComponent.resolveWhitelabelLocale();
    this.productContextService.setLocale(locale);
    this.translate.use(locale);

    const config = this.route.snapshot.data['whitelabelConfig'];
    if (config) {
      this.staticLinkBoxes = config.staticLinkBoxes;
      this.productContextService.setAvailableLanguages(config.availableLanguages);
    }
  }

  getImage(type: string): string {
    return WhitelabelComponent.IMAGE_MAP[type] ?? 'assets/img/noimage.png';
  }

  getCTAKey(type: string): string {
    return WhitelabelComponent.CTA_KEY_MAP[type] ?? 'link.more';
  }

  /** No serial number for whitelabel — strip any {serialnumber} placeholder. */
  buildLink(link: string): string {
    return link.replace(/[?&][^?&#]*\{serialnumber\}/, '').replace(/\{serialnumber\}/g, '');
  }
}
